import React from "react";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import * as styles from "../styles/footer.module.scss";
import { useStaticQuery, graphql, Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      links: contentfulNavigation {
        desktopNavigation {
          title
          slug
          id
        }
      }
    }
  `);
  return (
    <footer className={styles.foot}>
      <div className="container">
        <div>
          <StaticImage
            src="../images/ipumc-methodist-icon.png"
            alt="Irving Park United Methodist Church Logo"
            width={30}
            height={30}
            placeholder="none"
            layout="fixed"
          />
          <br></br>
          <p>Irving Park United Methodist Church</p>
          <p>
            <a
              href="https://www.google.com/maps?sca_esv=572931913&rlz=1C5CHFA_enUS1026US1030&output=search&q=1510+W.+Cone+Blvd.,+Greensboro,+NC+27408&source=lnms&entry=mc&sa=X&ved=2ahUKEwj8q9bKnvGBAxV7ElkFHZdsDqUQ0pQJegQIDBAB"
              target="_blank"
              rel="noreferrer"
            >
              1510 W. Cone Blvd., <br></br>Greensboro, NC 27408
            </a>
          </p>
          <br></br>
          <p>
            <a href="mailto:irvingparkunited@gmail.com">
              irvingparkunited@gmail.com
            </a>
          </p>
          <p>
            <a href="tel:336-288-2323">336-288-2323</a>
          </p>
        </div>
        <div>
          <h3>Quick Links</h3>
          <ul>
            {data.links.desktopNavigation.map((node, index) => (
              <li key={`${node.slug}${index}`}>
                <p>
                  <Link to={`/${node.slug}`}>{node.title}</Link>
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.social}>
          <h3>Connect with Us</h3>
          <a
            href="https://www.facebook.com/ipumc/"
            target="_blank"
            rel="noreferrer"
            aria-label="Irving Park United Methodist Church Facebook"
          >
            <FaFacebook />
          </a>
          <a
            href="http://www.youtube.com/@IrvingParkChurch"
            target="_blank"
            rel="noreferrer"
            aria-label="Irving Park United Methodist Church YouTube"
          >
            <FaYoutube />
          </a>
          <p className={styles.textMessages}><a href="https://app.onechurchsoftware.com/ipumc/forms/10">Subscribe to Texts</a></p>
        </div>
        <div className={styles.copyright}>
          <p>
            © {new Date().getFullYear()} Irving Park United Methodist Church.
            All Rights Reserved. | <span> </span>
            <a
              href="https://www.jonathanchawkins.com"
              target="_blank"
              rel="noreferrer"
            >
              Website by Jonathan Hawkins
            </a>
            <span> | </span>
            <a
              href="/privacy-policy"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
